<template>
  <v-card>
    <div style="background-color: #f7f7f7;">
      <div class="pa-4 pb-0 accent--text">
        <v-btn @click="back" fab x-small class="mb-4 accent">
          <font-awesome-icon icon="arrow-left" />
        </v-btn>
        <h2 style="font-size: 60px; font-weight: 200;">Offers</h2>
      </div>
    </div>
    <v-tabs v-model="tab" icons-and-text grow>
      <v-tabs-slider></v-tabs-slider>

      <v-tab
        v-for="(category, index) in categories"
        :key="index"
        :href="`#${index}`"
      >{{ category.tabName }}</v-tab>

      <v-tab-item v-for="(category, index) in categories" :key="index" :value="`${index}`">
        <category-offers
          :category="category.apiName"
          :offers="category.offers"
          :loading="category.loading"
        ></category-offers>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import categoryOffers from "@/components/categories/categoryOffers";

export default {
  components: {
    categoryOffers
  },

  data() {
    return {
      tab: "-1",
      categories: [
        { tabName: "Eat", apiName: "eat", offers: [], loading: false },
        { tabName: "Shop", apiName: "shop", offers: [], loading: false },
        { tabName: "Do", apiName: "cool", offers: [], loading: false }
      ]
    };
  },

  methods: {
    ...mapActions({
      getCategory: "offers/fetchCategoryOffers"
    }),

    back() {
      this.$emit("back");
    }
  },

  computed: {
    ...mapState({
      offers: state => state.offers
    })
  },

  watch: {
    tab(val) {
      this.getCategory(this.categories[parseInt(val)].apiName).then(res => {
        this.categories[val].offers = res;
      });
    }
  },

  mounted() {
    this.tab = "0";
  }
};
</script>

<style lang="scss" scoped></style>
